import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../../action';
import * as c from '../../constant';

function AppraisalTab({
  getMachineryHistoryAppraisalList,
  machineryAppraisalList,
  historyId,
  isLoading,
}) {
  useEffect(() => {
    if (_.isEmpty(historyId)) return;
    getMachineryHistoryAppraisalList(historyId);
  }, [historyId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <div className="table-div">
                <div className="row my-3 mx-2">
                  <table className="css-table table table-borderless table-sm table-striped table-hover">
                    <thead className="table-header">
                      <tr>
                        <td className="font-weight-bold">Kind of Machinery</td>
                        <td className="font-weight-bold">Brand and Model</td>
                        <td className="font-weight-bold">Capacity</td>
                        <td className="font-weight-bold">Date Acquired</td>
                        <td className="font-weight-bold">Condition</td>
                        <td className="font-weight-bold">
                          Estimated Economic Life
                        </td>
                        <td className="font-weight-bold">Year Installed</td>
                        <td className="font-weight-bold">
                          Year of Initial Operation
                        </td>
                        <td className="font-weight-bold">Original Cost</td>
                        <td className="font-weight-bold">Conversion Factor</td>
                        <td className="font-weight-bold">RCN</td>
                        <td className="font-weight-bold">No. of Years Used</td>
                        <td className="font-weight-bold">
                          Total Depreciation %
                        </td>
                        <td className="font-weight-bold">
                          Total Depreciation Value
                        </td>
                        <td className="font-weight-bold"> Depreciated Value</td>
                      </tr>
                    </thead>
                    <tbody>
                      {machineryAppraisalList &&
                        machineryAppraisalList.length <= 0 && (
                          <tr className="text-center">
                            <td className="history-color" colSpan="9">
                              No data
                            </td>
                          </tr>
                        )}
                      {machineryAppraisalList &&
                        machineryAppraisalList.map((item) => (
                          <tr key={item.id}>
                            <td className="history-color">
                              {_.get(
                                item,
                                'included.machineryMachine.attributes.name'
                              ) || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.brand_and_model') ||
                                '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.capacity') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.date_acquired') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.condition') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(
                                item,
                                'attributes.economic_life_estimated'
                              ) || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.year_installed') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(
                                item,
                                'attributes.year_of_initial_operation'
                              ) || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.original_cost') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.conversion_factor') ||
                                '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.rcn') || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.no_of_year_used') || 0}
                            </td>
                            <td className="history-color">
                              {_.get(
                                item,
                                'attributes.total_depreciation_percent'
                              ) || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(
                                item,
                                'attributes.total_depreciation_value'
                              ) || '--'}
                            </td>
                            <td className="history-color">
                              {_.get(item, 'attributes.depreciation_value') ||
                                '--'}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

AppraisalTab.defaultProps = {
  historyId: '',
};

AppraisalTab.propTypes = {
  getMachineryHistoryAppraisalList: PropTypes.instanceOf(Function).isRequired,
  machineryAppraisalList: PropTypes.instanceOf(Array).isRequired,
  historyId: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  machineryAppraisalList:
    _.get(api, `${c.GET_MACHINERY_APPRAISAL_HISTORY_LIST}.list`) || [],
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_MACHINERY_APPRAISAL_HISTORY_LIST) >
    -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AppraisalTab);
